export type PropertyMegaMenuKind = 'sale' | 'rent' | 'new'

export type PropertyTypeMenuItem = {
  label: string
  slug: string
  isNew?: boolean
}

export type PropertyLocationMenuItem = {
  province: string
  slug: string
  cities: string[]
}

export type PropertyMegaMenuConfig = {
  id: PropertyMegaMenuKind
  label: string
  eyebrow: string
  title: string
  description: string
  locationPrefix: string
  hrefPrefix: string
  highlightCity: string
}

export const PROPERTY_TYPE_MENU_ITEMS: PropertyTypeMenuItem[] = [
  { label: 'Rumah', slug: 'rumah' },
  { label: 'Apartemen', slug: 'apartemen' },
  { label: 'Tanah', slug: 'tanah' },
  { label: 'Ruko', slug: 'ruko' },
  { label: 'Pabrik', slug: 'pabrik' },
  { label: 'Perkantoran', slug: 'perkantoran' },
  { label: 'Ruang Usaha', slug: 'ruang-usaha' },
  { label: 'Gudang', slug: 'gudang' },
  { label: 'Villa', slug: 'villa', isNew: true },
  { label: 'Kost', slug: 'kost', isNew: true },
  { label: 'Hotel', slug: 'hotel' },
]

export const PROPERTY_MEGA_MENU_CONFIGS: PropertyMegaMenuConfig[] = [
  {
    id: 'sale',
    label: 'Dijual',
    eyebrow: 'Properti dijual',
    title: 'Cari properti dijual berdasarkan tipe dan kota.',
    description: 'Rumah, apartemen, tanah, ruko, gudang, villa, sampai ruang usaha dari kota populer di Indonesia.',
    locationPrefix: 'Properti Dijual di',
    hrefPrefix: '/jual',
    highlightCity: 'Bandung',
  },
  {
    id: 'rent',
    label: 'Disewa',
    eyebrow: 'Properti disewa',
    title: 'Temukan properti sewa yang lokasinya pas.',
    description: 'Pilih tipe properti dan kota tujuan untuk menemukan listing sewa yang relevan.',
    locationPrefix: 'Properti Disewa di',
    hrefPrefix: '/sewa',
    highlightCity: 'Jakarta Selatan',
  },
  {
    id: 'new',
    label: 'Properti Baru',
    eyebrow: 'Proyek baru',
    title: 'Lihat properti baru dan proyek developer.',
    description: 'Eksplorasi rumah baru, apartemen baru, cluster, dan unit komersial yang sedang dipasarkan.',
    locationPrefix: 'Properti Baru di',
    hrefPrefix: '/properti-baru',
    highlightCity: 'Tangerang',
  },
]

export const PROPERTY_LOCATION_MENU_ITEMS: PropertyLocationMenuItem[] = [
  { province: 'Aceh', slug: 'aceh', cities: ['Banda Aceh', 'Aceh Besar', 'Lhokseumawe', 'Langsa', 'Sabang'] },
  { province: 'Bali', slug: 'bali', cities: ['Denpasar', 'Badung', 'Canggu', 'Ubud', 'Gianyar', 'Tabanan'] },
  { province: 'Banten', slug: 'banten', cities: ['Tangerang', 'Tangerang Selatan', 'Serpong', 'Cilegon', 'Serang', 'Pandeglang'] },
  { province: 'Bengkulu', slug: 'bengkulu', cities: ['Bengkulu', 'Rejang Lebong', 'Seluma', 'Bengkulu Tengah'] },
  { province: 'Daerah Istimewa Yogyakarta', slug: 'daerah-istimewa-yogyakarta', cities: ['Yogyakarta', 'Sleman', 'Bantul', 'Gunungkidul', 'Kulon Progo'] },
  { province: 'DKI Jakarta', slug: 'dki-jakarta', cities: ['Jakarta Selatan', 'Jakarta Barat', 'Jakarta Utara', 'Jakarta Timur', 'Jakarta Pusat'] },
  { province: 'Gorontalo', slug: 'gorontalo', cities: ['Gorontalo', 'Bone Bolango', 'Boalemo', 'Pohuwato'] },
  { province: 'Jambi', slug: 'jambi', cities: ['Jambi', 'Muaro Jambi', 'Sungai Penuh', 'Bungo', 'Tebo'] },
  { province: 'Jawa Barat', slug: 'jawa-barat', cities: ['Bandung', 'Bekasi', 'Bogor', 'Depok', 'Cimahi', 'Cirebon', 'Karawang', 'Sukabumi'] },
  { province: 'Jawa Tengah', slug: 'jawa-tengah', cities: ['Semarang', 'Solo', 'Magelang', 'Salatiga', 'Purwokerto', 'Tegal', 'Kudus'] },
  { province: 'Jawa Timur', slug: 'jawa-timur', cities: ['Surabaya', 'Malang', 'Sidoarjo', 'Gresik', 'Kediri', 'Madiun', 'Banyuwangi'] },
  { province: 'Kalimantan Barat', slug: 'kalimantan-barat', cities: ['Pontianak', 'Singkawang', 'Kubu Raya', 'Ketapang', 'Sambas'] },
  { province: 'Kalimantan Selatan', slug: 'kalimantan-selatan', cities: ['Banjarmasin', 'Banjarbaru', 'Banjar', 'Tanah Laut', 'Kotabaru'] },
  { province: 'Kalimantan Tengah', slug: 'kalimantan-tengah', cities: ['Palangka Raya', 'Kotawaringin Barat', 'Kotawaringin Timur', 'Kapuas'] },
  { province: 'Kalimantan Timur', slug: 'kalimantan-timur', cities: ['Balikpapan', 'Samarinda', 'Bontang', 'Kutai Kartanegara', 'Penajam Paser Utara'] },
  { province: 'Kalimantan Utara', slug: 'kalimantan-utara', cities: ['Tarakan', 'Tanjung Selor', 'Nunukan', 'Malinau'] },
  { province: 'Kepulauan Bangka Belitung', slug: 'kepulauan-bangka-belitung', cities: ['Pangkal Pinang', 'Bangka', 'Belitung', 'Bangka Tengah'] },
  { province: 'Kepulauan Riau', slug: 'kepulauan-riau', cities: ['Batam', 'Tanjung Pinang', 'Bintan', 'Karimun', 'Natuna'] },
  { province: 'Lampung', slug: 'lampung', cities: ['Bandar Lampung', 'Metro', 'Lampung Selatan', 'Pringsewu', 'Lampung Tengah'] },
  { province: 'Maluku', slug: 'maluku', cities: ['Ambon', 'Tual', 'Maluku Tengah', 'Seram Bagian Barat'] },
  { province: 'Nusa Tenggara Barat', slug: 'nusa-tenggara-barat', cities: ['Mataram', 'Lombok Barat', 'Lombok Tengah', 'Lombok Timur', 'Sumbawa'] },
  { province: 'Nusa Tenggara Timur', slug: 'nusa-tenggara-timur', cities: ['Kupang', 'Manggarai Barat', 'Ende', 'Sikka', 'Sumba Timur'] },
  { province: 'Others', slug: 'others', cities: ['Indonesia', 'Kota Lainnya', 'Kabupaten Lainnya'] },
  { province: 'Papua', slug: 'papua', cities: ['Jayapura', 'Mimika', 'Merauke', 'Biak Numfor', 'Nabire'] },
  { province: 'Papua Barat', slug: 'papua-barat', cities: ['Manokwari', 'Sorong', 'Fakfak', 'Kaimana', 'Raja Ampat'] },
  { province: 'Riau', slug: 'riau', cities: ['Pekanbaru', 'Dumai', 'Siak', 'Kampar', 'Bengkalis'] },
  { province: 'Sulawesi Barat', slug: 'sulawesi-barat', cities: ['Mamuju', 'Majene', 'Polewali Mandar', 'Pasangkayu'] },
  { province: 'Sulawesi Selatan', slug: 'sulawesi-selatan', cities: ['Makassar', 'Gowa', 'Maros', 'Parepare', 'Palopo', 'Toraja'] },
  { province: 'Sulawesi Tengah', slug: 'sulawesi-tengah', cities: ['Palu', 'Donggala', 'Poso', 'Morowali', 'Banggai'] },
  { province: 'Sulawesi Tenggara', slug: 'sulawesi-tenggara', cities: ['Kendari', 'Bau-Bau', 'Kolaka', 'Muna', 'Konawe'] },
  { province: 'Sulawesi Utara', slug: 'sulawesi-utara', cities: ['Manado', 'Bitung', 'Tomohon', 'Minahasa', 'Bolaang Mongondow'] },
  { province: 'Sumatera Barat', slug: 'sumatera-barat', cities: ['Padang', 'Bukittinggi', 'Payakumbuh', 'Pariaman', 'Solok'] },
  { province: 'Sumatera Selatan', slug: 'sumatera-selatan', cities: ['Palembang', 'Prabumulih', 'Lubuklinggau', 'Ogan Ilir', 'Banyuasin'] },
  { province: 'Sumatera Utara', slug: 'sumatera-utara', cities: ['Medan', 'Binjai', 'Deli Serdang', 'Pematangsiantar', 'Tebing Tinggi', 'Karo'] },
]

export const POPULAR_PROPERTY_LOCATION_SLUGS = [
  'dki-jakarta',
  'banten',
  'jawa-barat',
  'jawa-tengah',
  'jawa-timur',
  'daerah-istimewa-yogyakarta',
  'bali',
  'sumatera-utara',
  'sumatera-selatan',
  'kepulauan-riau',
  'kalimantan-timur',
  'sulawesi-selatan',
] as const

export const POPULAR_PROPERTY_LOCATION_ITEMS = POPULAR_PROPERTY_LOCATION_SLUGS
  .map((slug) => PROPERTY_LOCATION_MENU_ITEMS.find((location) => location.slug === slug))
  .filter((location): location is PropertyLocationMenuItem => Boolean(location))

export function buildPropertyHref(prefix: string, segment: string) {
  return `${prefix}/${segment}`.replace(/\/+/g, '/')
}

export function propertySlug(value: string) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
